$(document).ready(function () {
    parallax('.slider');
    $('<div class="we_create_slogan"></div>').appendTo('.slider_big .header-img');
});

$(window).on('resize', function () {
    if ($(window).width() <= 767) {
        $(document).ready(function () {
            var divHeight = $('.slider.slider_big.slider_big-caption-left .header-img .caption-wrapper').height();
            $('.single-header').css('padding-bottom', divHeight);
            $('.slider.slider_big.slider_big-caption-left .header-img .caption-wrapper').css('bottom', -divHeight);
        });
    }
}).resize();


jQuery(document).ready(function () {
    jQuery("a").on('click', function (event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            jQuery('html, body').animate({
                scrollTop: jQuery(hash).offset().top - 75
            }, 1200, function () {
                window.location.hash = hash;
            });
        } // End if
    });
});